<template>
    <footer class="main-footer d-flex justify-content-between">
        <div v-html="$t('footer.text', {year: year, url: '#', name: $t('app.name')})"></div>
        <div v-html="appVersion ? appVersion : $t('footer.version')"></div>
    </footer>
</template>

<script>
export default {
    props: {appVersion:String},
    computed: {
        year() {
            return moment().format('YYYY');
        }
    }
}
</script>
